import { FormShell, FormGrid, FormField, FormFooter } from '../../../../../generic/ui/FormLayout'
import { AccentButton } from '../../../../../generic/ui/Button'
import LocationSelector from '../../../../../generic/ui/Selectors/LocationSelector'
import { ILocationForPallet } from '../../../../../modules/API/Pallets/models/locations'
import { IPalletListWithDetails } from '../../../../../modules/API/Pallets/models/palletList'
import PalletActionLayout from '../../Pallets/shared/components/PalletActionLayout'
import PalletLookupField from '../../Pallets/shared/components/PalletLookupField'
import FoundPalletCard from '../../Pallets/shared/components/FoundPalletCard'

type Props = {
  palletNumber: string
  setPalletNumber: (value: string) => void
  isExternal: boolean
  setIsExternal: (value: boolean) => void
  palletFound: IPalletListWithDetails | null
  findPallet: (value?: string) => void
  locations: ILocationForPallet[]
  selectedLocation: ILocationForPallet | null
  setSelectedLocation: (location: ILocationForPallet | null) => void
  submit: () => void
  canSubmit: boolean
}

const PalletLocationView = ({
  palletNumber,
  setPalletNumber,
  isExternal,
  setIsExternal,
  palletFound,
  findPallet,
  locations,
  selectedLocation,
  setSelectedLocation,
  submit,
  canSubmit,
}: Props) => (
  <PalletActionLayout title='עדכון איתור למשטח'>
    <FormShell>
      <FormGrid>
        <FormField label='מספר משטח' fullWidth>
          <PalletLookupField
            palletNumber={palletNumber}
            onPalletNumberChange={setPalletNumber}
            onScan={(value) => {
              setPalletNumber(value)
              findPallet(value)
            }}
            isExternal={isExternal}
            onToggle={setIsExternal}
          />
        </FormField>

        {palletFound && (
          <FormField fullWidth>
            <FoundPalletCard pallet={palletFound} />
          </FormField>
        )}

        {palletFound && (
          <FormField label='איתור למשטח' fullWidth>
            <LocationSelector
              locations={locations}
              value={selectedLocation}
              onSelect={setSelectedLocation}
            />
          </FormField>
        )}
      </FormGrid>

      {canSubmit && (
        <FormFooter>
          <AccentButton type='button' onClick={submit} fullWidth={false}>
            עדכן
          </AccentButton>
        </FormFooter>
      )}
    </FormShell>
  </PalletActionLayout>
)

export default PalletLocationView
